import React, { forwardRef } from 'react'
import { Textarea } from '@ow/comps'

const Render = function ({ opts = {}, onChange, onBlur, value }, ref) {
  const { slug, readonly, hint, firstSeparators, secondarySeparators } = opts

  const onTextChange = (e) => {
    let str = e.target.value
    if (firstSeparators && firstSeparators.length > 0) {
      const freg = new RegExp(`[${firstSeparators}]`)
      str = str.split(freg).filter((v) => v)
    }
    if (secondarySeparators && secondarySeparators.length > 0) {
      const sreg = new RegExp(`[${secondarySeparators}]`)
      const arr = [...str]
      str = arr.map((item) => {
        return item.split(sreg).filter((v) => v)
      })
    }
    if (onChange) {
      onChange(str)
    }
  }

  return (
    <div className="relative flex flex-row items-center" ref={ref}>
      <Textarea
        className="flex-1"
        style={{
          paddingLeft: '0.75rem',
          paddingRight: '0.75rem',
          fontSize: '0.8125rem',
        }}
        defaultValue={value}
        name={slug}
        onChange={onTextChange}
        onBlur={onBlur}
        rows="3"
        readonly={readonly}
        placeholder={hint}
      />
    </div>
  )
}

export default forwardRef(Render)
